import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AwarenessCampaignData } from "../../../models/AwarenessCampaign";
import { LoadableContext } from "../../store";

export enum CampaignAddressesDisplayMode {
    LIST = 'list',
    MAP = 'map',
};

type SelectedAwarenessCampaignContext = LoadableContext & {
    selectedAwarenessCampaign: AwarenessCampaignData | null;
    addressesDisplayMode: CampaignAddressesDisplayMode;
    confirmCompleteDialogOpen: boolean;
};

const initialState: SelectedAwarenessCampaignContext = {
    loading: false, // track when get/retrieving the campaign's firestore document
    error: null,
    selectedAwarenessCampaign: null,
    addressesDisplayMode: CampaignAddressesDisplayMode.LIST,
    confirmCompleteDialogOpen: false,
};

export const selectedAwarenessCampaignSlice = createSlice({
    name: 'selected_awareness_campaign',
    initialState,
    reducers: {
        startLoading: (state) => {
            state.loading = true;
            state.error = null;
        },
        setSelected: (state, { payload: mission }: PayloadAction<AwarenessCampaignData | null>) => {
            state.loading = false;
            state.selectedAwarenessCampaign = mission;
        },
        updateSelected: (state, { payload }: PayloadAction<Partial<AwarenessCampaignData>>) => {
            state.loading = false;
            if (state.selectedAwarenessCampaign) {
                state.selectedAwarenessCampaign = { ...state.selectedAwarenessCampaign, ...payload };
            }
        },
        setError: (state, { payload }: PayloadAction<string>) => {
            state.loading = false;
            state.error = payload;
        },
        clearSelected: (state) => {
            state.selectedAwarenessCampaign = null;
        },
        stopLoading: (state) => {
            state.loading = false;
            state.error = null;
        },
        setAddressesDisplayMode: (state, { payload }: PayloadAction<CampaignAddressesDisplayMode>) => {
            state.addressesDisplayMode = payload;
        },
        setConfirmCompleteDialogOpen: (state, { payload }: PayloadAction<boolean>) => {
            state.confirmCompleteDialogOpen = payload;
        },
    },
});

export const SelectedAwarenessCampaignActions = selectedAwarenessCampaignSlice.actions;

const SelectedAwarenessCampaignReducer = selectedAwarenessCampaignSlice.reducer;

export default SelectedAwarenessCampaignReducer;
